module.exports = __webpack_public_path__ + "media/packs/images/flags/BY-05bfd3208368c39d6514c85a5ede7b3d.svg";